import { useState, useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { OverlayContext } from "../../../context/OverlayContext";
import { ToastContext } from "../../../context/ToastContext";
import { Typography, Button, Form, Image as AntImage } from "antd";
import ImagesService from "../../../services/crud/ImageService";
import Image, { UpdateImageRequest } from "../../../models/Image";
import DescriptionDataList from "../../../components/DescriptionDataList";
import { ImageForm } from "../../../components/forms/ImageForm";
import { GoBackButton } from "../../../components/GoBackButton";

const ImageView = () => {
  const { loading, loadMessage } = useContext(ToastContext);
  const { openModal, closeModal } = useContext(OverlayContext);
  const [form] = Form.useForm<UpdateImageRequest>();
  const { id } = useParams();
  const [image, setImage] = useState<Image>({} as Image);

  const load = () => {
    if (id) {
      form.resetFields();
      loadMessage("Loading Image item...", () =>
        ImagesService.getImage(id).then((data) => {
          setImage(data);
        })
      );
    }
  };
  useEffect(load, [id, form]);

  const openEditModal = () => {
    let uploadFile = null;
    const onSelectFile = (file: File) => {
      uploadFile = file;
    };
    form.resetFields();
    console.log('update', id);
    openModal({
      title: "Edit Image",
      content: <ImageForm form={form} id={id} onSelectFile={onSelectFile} />,
      onOk: () => {
        form.validateFields().then(async (values) => {
          console.log('update', id);
          loadMessage("Updating Image...", async () => {
            console.log('update', id);
            ImagesService.editImage(id, new UpdateImageRequest({
              name: values.name,
              alt: values.alt,
              file: uploadFile,
            })).then(load);
            closeModal();
          });
        });
      },
    });
  };

  return (
    <div style={{paddingBottom: 20}}>
      <GoBackButton></GoBackButton>
      <Typography.Title level={2}>Image</Typography.Title>
      <div style={{marginLeft: 10, marginBottom: 10}}>
        <AntImage
          src={Image.getSrcUrl(image)}
          style={{maxHeight: 300, height: image.height, aspectRatio: image.aspectRatio}}
        /><br/>
      </div>
      <DescriptionDataList data={{
        ...image,
        sizeBytes: undefined,
        fileSize: `${Math.round(image.sizeBytes / 100)/10} kB`,
        url: <a href={Image.getSrcUrl(image)} target="_blank">{Image.getSrcUrl(image)}</a>,
      }} />
      <Button type="primary" onClick={openEditModal}>
        Edit Image
      </Button>
    </div>
  );
};

export default ImageView;


